import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";

export const getMisuseReportDetails = (misuse_report_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/misuse/'+misuse_report_id ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}


export const getMisuseReports = (onCompleteFunc) => {

    const url = Globals.APIFolder + '/misuse'

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}
